import { FC } from 'react';
import { HighlightRoute, Outbound } from 'ts/dynamic/interfaces/DynamicResponse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faPlane } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import Tooltip from 'components/ui/Tooltip/Tooltip';
import TicketRouteTime from './TicketRouteTime';
import { getElapsedStr } from 'utils/dynamic/dynamic';
import TickteBaggage from './TicketBaggage';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { blobUrl } from 'constants/generic';

interface DynamicTicketRouteProps {
  arrivalDaysDifference?: number;
  bound: Outbound;
  firstRoute?: boolean;
  onClickInfo?: () => void;
  highlighted?: HighlightRoute;
}

const DynamicTicketRoute: FC<DynamicTicketRouteProps> = ({ bound, highlighted, ...props }) => {
  const stops = bound.legCount - 1;
  const { t } = useTranslation();

  return (
    <div className="ticket-route ticket-route-short">
      <span className="ticket-airline">
        <img src={blobUrl + 'Airlines/' + bound.airline.code + '.png'} alt={bound.airline.code} />
      </span>
      <div className="ticket-data">
        <TicketRouteTime
          dateTime={bound.departureDateTime}
          airportDesc={bound.departureAirport.desc}
          airport={bound.departureAirport.code}
          highlighted={highlighted?.departure}
          isShort={true}
        />
        <div className="ticket-directions">
          <span className="stops-duration">{getElapsedStr(bound.elapsedDTime)}</span>
          <span className="line">
            <FontAwesomeIcon icon={faPlane} />
            {stops === 0 && (
              <span className="flight-direct-title">{t('filter.direct_flight')}</span>
            )}
            {stops === 1 && <span className="circle">1 {t('filter.stop')}</span>}
            {stops > 1 && (
              <span className="circle">
                {stops} {t('filter.stops')}
              </span>
            )}
          </span>
          {props.firstRoute && (
            <span
              onClick={() => props.onClickInfo && props.onClickInfo()}
              className="text-center mt-10"
            >
              <Tooltip
                content={t('flight.details_segment')}
                children={
                  <FontAwesomeIcon icon={faInfoCircle} className="text-contrast" size="lg" />
                }
              />
            </span>
          )}
        </div>
        <TicketRouteTime
          dateTime={bound.arrivalDateTime}
          airportDesc={bound.arrivalAirport.desc}
          airport={bound.arrivalAirport.code}
          highlighted={highlighted?.arrival}
          isShort={true}
        />
        <TickteBaggage bound={bound} />
      </div>
    </div>
  );
};

export default withErrorBoundary(DynamicTicketRoute, 'DynamicTicketRoute');
